// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"223":"home-page","940":"portfolio-page","987":"NotFound-page"}[chunkId] || chunkId) + "." + {"223":"109ad3ae","462":"4780bbaf","940":"a27778c2","987":"47598865"}[chunkId] + ".chunk.js";
};